import script from "./AdminTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTable.vue?vue&type=script&setup=true&lang=js"

import "./AdminTable.vue?vue&type=style&index=0&id=7e48e51a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e48e51a"]])

export default __exports__